import { publicHooks } from '../data';
import { schoolSocialLinks } from '../content/social';
import { Link } from '../router';

export function ActivityDetailPage({ id }: { id: string }) {
  const { data: activities, loading } = publicHooks.useActivities();
  const activity = activities.find((item) => item.id === id);

  if (loading && !activity) return <section className="content-section"><p>Loading activity…</p></section>;
  if (!activity) return <section className="content-section activity-not-found"><p className="eyebrow">Activity stories</p><h1>Activity not found.</h1><Link className="arrow-link" to="/activities">← All activities</Link></section>;

  const pageUrl = typeof window === 'undefined' ? `https://htlkaren.org/activities/${encodeURIComponent(activity.id)}` : window.location.href;
  const facebookShareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(pageUrl)}`;
  const facebookDestination = activity.socialPostUrl ?? schoolSocialLinks.facebook;

  return <article className="activity-detail-page">
    <header className="activity-detail-header content-section">
      <Link className="story-back" to="/activities">← All activities</Link>
      <div className="activity-detail-heading">
        <div><p className="eyebrow">{activity.year} activity</p><h1>{activity.title}</h1></div>
        <p>{activity.description}</p>
      </div>
    </header>
    <figure className="activity-detail-hero">
      <img src={activity.images[0].url} alt={activity.images[0].alt} width="1920" height="1280"/>
    </figure>
    <div className="activity-detail-content content-section">
      <div className="activity-detail-body">
        <p className="section-kicker">The full story</p>
        {(activity.body ?? [activity.description]).filter(Boolean).map((paragraph) => <p key={paragraph}>{paragraph}</p>)}
        {activity.images.length > 1 && <div className="activity-detail-gallery">{activity.images.slice(1).map((image) => <figure key={image.url}><img src={image.url} alt={image.alt} loading="lazy"/></figure>)}</div>}
      </div>
      <aside className="activity-social-panel" aria-label="Activity social links">
        <p className="section-kicker">Follow and share</p>
        <h2>Stay connected.</h2>
        <p>See school updates on the official Hsa Thoo Lei Facebook page, or share this activity with your community.</p>
        <div className="activity-social-links">
          <a href={facebookDestination} target="_blank" rel="noreferrer">{activity.socialPostUrl ? 'View the related Facebook post' : 'Hsa Thoo Lei on Facebook'} <span aria-hidden="true">↗</span></a>
          <a href={facebookShareUrl} target="_blank" rel="noreferrer">Share this activity <span aria-hidden="true">↗</span></a>
        </div>
        <p className="activity-social-note">Instagram and X will appear here after the school confirms its official profiles.</p>
      </aside>
    </div>
  </article>;
}
